import { useEffect, useState } from 'react';
import LogoutModal from '../Modal/LogoutModal';
import NotificationModal from '../Modal/NotificationModal';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import { callApi, IApiErrorResponse } from '@/api/callApi';
import {
  authChannel,
  capitalizeFirstLetter,
  deleteCookies,
  showToastNotification,
} from '@/utility/helper';
import { useDispatch } from 'react-redux';
import {
  logout,
  setActiveSidebarTab,
  setAuthenticated,
  setNotification,
  setNotificationCount,
  setScrollPosition,
  setSideBarOpen,
  setTableView,
  setUserData,
  setUserWebsiteId,
} from '@/redux/features/UserSlice';
import { useNavigate } from 'react-router-dom';
import { RoutesLink } from '@/utility/RouteLinks';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { INotificationRespone } from '@/pages/Notification/Notification';
import { INotificationCountRes } from '@/interfaces/common.model';
const Header: React.FC = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const sidebarOpen = useSelector(
    (state: RootState) => state.user?.isSideBarOpen,
  );
  const userDetails = useSelector((state: RootState) => state?.user?.user);
  console.log(userDetails);
  const notification = useSelector(
    (state: RootState) => state?.user?.notification,
  );
  const notificationCount = useSelector(
    (state: RootState) => state?.user?.notificationCount,
  );
  const [logOutModal, setLogoutModal] = useState<boolean>(false);
  const [logoutLoading, setLogoutLoading] = useState<boolean>(false);
  const dispatch = useDispatch();
  const toggle = () => {
    // setLogoutLoading(true);
    setLogoutModal(!logOutModal);
  };

  useEffect(() => {
    getNotificationCount();
  }, []);
  const getNotificationList = async () => {
    try {
      setIsLoading(true);
      const apiURL = API_URL + API_ENDPOINT?.getNotification;
      const response: INotificationRespone = await callApi(apiURL, {
        method: 'GET',
      });
      setIsLoading(false);
      console.log(response);
      if (response?.status === true) {
        const newNotifications = (response?.data?.notification || []).map(
          (n) => ({
            ...n,
            data: typeof n.data === 'string' ? JSON.parse(n.data) : n.data,
          }),
        );
        dispatch(setNotification(newNotifications));
        if (notificationCount && notificationCount?.unseenNotitfication > 0) {
          dispatch(
            setNotificationCount({
              ...notificationCount,
              unseenNotitfication: 0,
            }),
          );
        }
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    }
  };
  const getNotificationCount = async () => {
    try {
      const response: INotificationCountRes = await callApi(
        API_URL + API_ENDPOINT.getNotificationCount,
        {
          method: 'GET',
        },
      );
      if (response?.status) {
        dispatch(setNotificationCount(response?.data));
        if (response?.data?.willRefreshSystem) {
          handleLogout();
        }
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    }
  };
  const handleLogout = async () => {
    try {
      const accessToken = localStorage.getItem(
        import.meta.env.VITE_BUSINESS + 'token',
      );
      const deviceId = localStorage.getItem(
        import.meta.env.VITE_BUSINESS + 'deviceId',
      );
      const API = `${API_URL}${API_ENDPOINT?.logout}?deviceId=${deviceId}`;
      setLogoutLoading(true);
      const response = await callApi<{
        status: boolean;
        message: string;
      }>(API, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      if (response?.status) {
        showToastNotification('success', response?.message);
        dispatch(logout());
        dispatch(setAuthenticated(false));
        dispatch(setScrollPosition(0));
        dispatch(setUserData(null));
        dispatch(setUserWebsiteId(''));
        dispatch(setSideBarOpen(false));
        dispatch(setActiveSidebarTab(-1));
        dispatch(setTableView('table'));
        deleteCookies(import.meta.env.VITE_BUSINESS + 'token');
        deleteCookies(import.meta.env.VITE_BUSINESS + 'refreshToken');
        localStorage.removeItem(import.meta.env.VITE_BUSINESS + 'deviceId');
        localStorage.removeItem(import.meta.env.VITE_BUSINESS + 'fcmToken');
        authChannel.postMessage('logout');
        // window.location.reload();
        navigate(RoutesLink?.Login);
      } else {
        showToastNotification('danger', response?.message);
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setLogoutLoading(false);
    }
  };
  return (
    <>
      <header className="header">
        <nav className="navbar navbar-expand-lg">
          <div className="container-fluid d-flex justify-content-end">
            <div className="dropdown d-block d-lg-none responsive_dropdown me-2">
              <button
                className="btn dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="far fa-user" />
              </button>
              <ul className="dropdown-menu rounded-3 shadow">
                {userDetails?.type != 1 && (
                  <li>
                    <a
                      className="dropdown-item"
                      role="button"
                      onClick={() => navigate(RoutesLink?.profile)}
                    >
                      <i className="far fa-user" />
                      Profile
                    </a>
                  </li>
                )}
                <li>
                  <a className="dropdown-item" role="button" onClick={toggle}>
                    <i className="fas fa-door-open" />
                    Logout
                  </a>
                </li>
              </ul>
            </div>
            <button
              className="navbar-toggler"
              type="button"
              onClick={() => dispatch(setSideBarOpen(!sidebarOpen))}
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse justify-content-between align-items-stretch">
              <div className="header-nav d-flex align-items-stretch justify-content-between w-100">
                <div className="user">
                  {userDetails?.type != 1 && (
                    <img
                      loading="lazy"
                      className="user-icon"
                      style={{ objectFit: 'contain' }}
                      src={userDetails?.profilePhoto ?? ''}
                    />
                  )}
                  <div>
                    <h4 className="title mb-0">
                      {capitalizeFirstLetter(userDetails?.name ?? '')}
                    </h4>
                    <p className="mb-0">{userDetails?.employeeCode}</p>
                  </div>
                </div>
                <ul className="d-flex align-items-center gap-4 list-unstyled mb-0">
                  {/* <li>
                    <div className="d-inline-flex align-items-center gap-3">
                      <div>
                        <button
                          id="btn-checkin"
                          className="btn btn-outline-primary py-2 rounded-3 flex-row gap-1"
                          onClick={() => toggleCheckIn('checkIn')}
                          disabled={!!attendanceStatus.checkInTime}
                        >
                          <span>
                            <i
                              className="bi bi-box-arrow-right"
                              style={{ fontSize: '16px' }}
                            ></i>
                          </span>
                          Check-In
                        </button>
                        <ClockTooltip target="btn-checkin" />
                      </div>

                      <div>
                        <button
                          id="btn-checkout"
                          className="btn btn-outline-primary py-2 rounded-3"
                          onClick={() => toggleCheckIn('checkOut')}
                          disabled={
                            !attendanceStatus.checkInTime ||
                            !!attendanceStatus.checkOutTime
                          }
                        >
                          <span>
                            <i
                              className="bi bi-box-arrow-left"
                              style={{ fontSize: '16px' }}
                            ></i>
                          </span>{' '}
                          Check-Out
                        </button>
                        <ClockTooltip target="btn-checkout" />
                      </div>
                    </div>
                  </li> */}

                  <li>
                    <p className="title mb-0">
                      {userDetails?.type != 1 &&
                        `${userDetails?.designation?.name} -
                  ${userDetails?.department?.name}`}
                    </p>
                  </li>
                  <li>
                    <div className="dropdown">
                      <button
                        className="btn dropdown-toggle"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        onClick={getNotificationList}
                      >
                        <i className="far fa-bell" />
                        {notificationCount &&
                          notificationCount?.unseenNotitfication > 0 && (
                            <span className="position-absolute top-1 start-100 translate-middle badge rounded-pill bg-danger px-2">
                              {notificationCount?.unseenNotitfication > 99
                                ? '99+'
                                : notificationCount?.unseenNotitfication}
                            </span>
                          )}
                      </button>
                      <NotificationModal
                        isLoading={isLoading}
                        notifications={notification}
                      />
                    </div>
                  </li>
                  <li>
                    <div className="dropdown">
                      <button
                        className="btn dropdown-toggle"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i className="far fa-user" />
                      </button>
                      <ul className="dropdown-menu rounded-3 shadow">
                        {userDetails?.type != 1 && (
                          <li>
                            <a
                              className="dropdown-item py-2"
                              role="button"
                              onClick={() => navigate(RoutesLink?.profile)}
                            >
                              <i className="far fa-user" />
                              Profile
                            </a>
                          </li>
                        )}
                        <li>
                          <a
                            className="dropdown-item py-2"
                            role="button"
                            onClick={toggle}
                          >
                            <i className="fas fa-door-open" />
                            Logout
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>
      </header>
      <LogoutModal
        isOpen={logOutModal}
        toggle={toggle}
        handleLogout={handleLogout}
        logoutLoading={logoutLoading}
      />
    </>
  );
};
export default Header;
